import _objectSpread from "@babel/runtime/helpers/objectSpread";
import * as Address from "./address";
import * as Auth from "./auth";
import * as User from "./user";
import * as Wishlist from "./wishlist";
// TODO: Add ability to pass custom fragments to mutations
export var MUTATIONS = {
  AccountUpdate: function AccountUpdate(client, options) {
    return client.mutate(_objectSpread({
      mutation: User.accountUpdate
    }, options));
  },
  AddWishlistProductVariant: function AddWishlistProductVariant(client, options) {
    return client.mutate(_objectSpread({
      mutation: Wishlist.addWishlistProductVariant
    }, options));
  },
  AddressTypeUpdate: function AddressTypeUpdate(client, options) {
    return client.mutate(_objectSpread({
      mutation: Address.setCustomerDefaultAddress
    }, options));
  },
  CreateUserAddress: function CreateUserAddress(client, options) {
    return client.mutate(_objectSpread({
      mutation: Address.createUserAddress
    }, options));
  },
  DeleteUserAddress: function DeleteUserAddress(client, options) {
    return client.mutate(_objectSpread({
      mutation: Address.deleteUserAddress
    }, options));
  },
  PasswordChange: function PasswordChange(client, options) {
    return client.mutate(_objectSpread({
      mutation: User.changeUserPassword
    }, options));
  },
  RemoveWishlistProductVariant: function RemoveWishlistProductVariant(client, options) {
    return client.mutate(_objectSpread({
      mutation: Wishlist.removeWishlistProductVariant
    }, options));
  },
  SetPassword: function SetPassword(client, options) {
    return client.mutate(_objectSpread({
      mutation: User.setPassword
    }, options));
  },
  TokenAuth: function TokenAuth(client, options) {
    return client.mutate(_objectSpread({
      mutation: Auth.tokenAuthMutation
    }, options));
  },
  UpdateUserAddress: function UpdateUserAddress(client, options) {
    return client.mutate(_objectSpread({
      mutation: Address.updateUserAddress
    }, options));
  }
};